<h1 class="sr-only"><span>SORTEOS OPORTUNO</span></h1>
<section class="info-sorteo-opt">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center my-auto">

                <div class="overlap-signature">
                    <span class="letter"> <span class="signature-text">Sorteos</span></span>
                    <h2 class="main-text">oportunos</h2>
                </div>

            </div>
        </div>
    </div>
</section>





<section class="about-sorteo-opt" data-aos="fade-up" data-aos-duration="3000">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="d-flex justify-content-center align-items-center">
                    <div class="logo-container text-center d-flex align-items-start">
                        <div class="number-one">
                            1
                            <span class="boleto">BOLETO</span>
                        </div>
                        <div class="text">
                            MÚLTIPLES <br>
                            OPORTUNIDADES <br>
                            <span class="highlight">DE GANAR</span>
                        </div>
                    </div>
                </div>




                <!-- <p class="subtitle">
                        ¡aquí te explicamos como!
                    </p> -->

                <p class="mt-4">
                  Con <strong>un solo boleto </strong> del <strong>Sorteo Anáhuac Magno participas</strong> también en los siguientes <strong>Sorteos Oportunos.</strong>
                </p>

                <p>
                </p>


                <!-- <a class="btn-stack mt-4 btn-sto" href="https://sorteoanahuaccompra.sorteoanahuac.mx/compra-en-linea-boletos-sorteo-anahuac{{utmUrl}}" target="_blank">
                        Comprar aquí
                    </a> -->
            </div>
        </div>
    </div>
</section>


<section class="opt-sa">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center my-auto">

                <div class="overlap-signature">

                    <span class="letter"> <span class="signature-text">Conoce</span></span>
                    <h2 class="main-text mb-5">nuestros sorteos </h2>
                </div>

            </div>
        </div>

    </div>
</section>


<section class="sorteos-cta ">
    <div class="container">
        <div class="row text-center justify-content-center">
            <div class="card-sorteo" style="width: 360px" routerLink="/sorteo-oportuno">
                <div class="card-header-assets">
                    <img class="esfera" src="/assets/images/sorteo2026/ball1.png">
                    <div class="img-wrapper">
                        <img class="img-principal" src="/assets/images/sorteo2026/banner-so1-vf.png"
                            alt="Primer Sorteo Oportuno">
                        <div class="overlay-text">
                            <h5>SORTEO<br>OPORTUNO</h5>
                        </div>
                    </div>
                </div>

                <div class="card-body text-center">
                    <h6 class="premio-titulo m-0">Primer Premio</h6>
                    <p class="cheque-info m-0">CHEQUE CERTIFICADO DE</p>
                    <h4 class="monto">$250,000.00</h4>
                    <p class="sede-info">UNIVERSIDAD ANÁHUAC <br> MÉXICO CAMPUS NORTE</p>
                    <p class="fecha purple">FECHA: <span>22 MAY</span></p>
                </div>
            </div>



            <div class="card-sorteo" style="width: 360px" routerLink="/sorteo-oportuno">
                <div class="card-header-assets">
                    <img class="esfera" src="/assets/images/sorteo2026/ball2.png">
                    <div class="img-wrapper">
                        <img class="img-principal" src="/assets/images/sorteo2026/banner-so2-vf.png"
                            alt="Segundo Sorteo Oportuno">
                        <div class="overlay-text">
                            <h5>SORTEO<br>OPORTUNO</h5>
                        </div>
                    </div>
                </div>

                <div class="card-body text-center">
                    <h6 class="premio-titulo m-0">Primer Premio</h6>
                    <p class="cheque-info m-0">CHEQUE CERTIFICADO DE</p>
                    <h4 class="monto">$250,000.00</h4>
                    <p class="sede-info">UNIVERSIDAD ANÁHUAC <br> MÉXICO CAMPUS NORTE</p>
                    <p class="fecha orange">FECHA: <span>21 AGO</span></p>
                </div>
            </div>



            <div class="card-sorteo" style="width: 360px" routerLink="/sorteo-oportuno">
                <div class="card-header-assets">
                    <img class="esfera" src="/assets/images/sorteo2026/ball3.png">
                    <div class="img-wrapper">
                        <img class="img-principal" src="/assets/images/sorteo2026/banner-so3.png"
                            alt="Tercer Sorteo Oportuno">
                        <div class="overlay-text">
                            <h5>SORTEO<br>OPORTUNO</h5>
                        </div>
                    </div>
                </div>

                <div class="card-body text-center">
                    <h6 class="premio-titulo m-0">Primer Premio</h6>
                    <p class="cheque-info m-0">CHEQUE CERTIFICADO DE</p>
                    <h4 class="monto">$250,000.00</h4>
                    <p class="sede-info">UNIVERSIDAD ANÁHUAC <br> MÉXICO CAMPUS NORTE</p>
                    <p class="fecha red">FECHA: <span>23 OCT</span></p>
                </div>
            </div>




        </div>
    </div>
</section>




<section class="award-opt" data-aos="fade-up" data-aos-duration="3000">
    <div class="container">
        <div class="row liquid-glass-btn container-liquid">
            <!-- <div class="col-md-12 text-center">
                <img class="esfera" src="/assets/images/sorteo2026/dinero.png" class="img-fluid">
            </div> -->
            <div class="col-md-12 text-center">

                <h3 class="liquid-glass-btn mb-5">
                    premios
                </h3>
            </div>


            <div class="col-md-12 text-center over">
                <table class="table table-borderless">
                    <thead>
                        <tr class="mb-4">
                            <th colspan="2" class="border-0">
                                <h4 class="liquid-glass-btn p-2 text-uppercase">Comprador</h4>
                            </th>
                            <th colspan="2" class="border-0">
                                <h4 class="liquid-glass-btn p-2 text-uppercase">Colaborador</h4>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn">1º Premio</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn fw-bold">$250,000.00</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn">1º Premio</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn fw-bold">$150,000.00</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn">2º Premio</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn fw-bold">$200,000.00</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn">2º Premio</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn fw-bold">$75,000.00</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn">3º Premio</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn fw-bold">$100,000.00</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn">3º Premio</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn fw-bold">$30,000.00</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn">4º Premio</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn fw-bold">$50,000.00</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn">4º Premio</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn fw-bold">$20,000.00</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn">5º Premio</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn fw-bold">$25,000.00</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn">5º Premio</div>
                            </td>
                            <td>
                                <div class="p-2 border-btn liquid-glass-btn fw-bold">$10,000.00</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</section>

<section class="info-opt">
    <div class="container">
        <div class="row">
            <div class="col-md 12">
                <p>
                    <span class="purple"> ¡Gracias por participar</span> y recuerda que tu <span class="orange">
                        boleto</span> incluye tu participación en nuestro
                    <span class="orange">Sorteo Magno</span> el <span class="purple"> 19 de noviembre</span> desde la
                    <span class="orange"> Universidad Ánahuac</span> <span class="purple"> Veracruz campus Córdoba! </span>
                </p>
            </div>
        </div>
    </div>
</section>






<!-- <section class="form-oportuno " data-aos="fade-up"
     data-aos-duration="3000">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <h2 class="pt-5 mt-5">
                    CONSULTA TU BOLETO
                </h2>
            </div>
            <div class="col-md-12">
                <div class="content-form">
                    <div class="content-fall">
                        <form class="form-all mt-4 "  #dataContact="ngForm" (ngSubmit)="sendDataContact(dataContact)">
                            <div class="row">
                                <div class="col-md-6">
                                    <p>Folio</p>
                                    <input type="text" class="form-control" folio ngModel id="folio" name="folio" #folio="ngModel" [(ngModel)]="dataSorteo.folio"  [ngClass]="{'is-invalid': folio.errors && (folio.touched || folio.dirty), 'is-valid': folio.valid}" placeholder="*Ingresa tu folio:" required  pattern="[0-9]+">
                                    <div  class="text-left invalid-feedback mb-2">
                                        <span>Solo se aceptan números</span>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <p>Correo</p>
                                    <input type="email" [ngClass]="{'is-invalid': correo.errors && (correo.touched || correo.dirty), 'is-valid':correo.valid}"  class="form-control" correo ngModel id="correo" name="correo" #correo="ngModel" [(ngModel)]="dataSorteo.correo" placeholder="*Ingrese su correo" required  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" maxlength="100">        
                                    <div class="text-left invalid-feedback mb-2">
                                        <span>Formato incorrecto</span>
                                    </div> 
                                </div>

                                <div class="col-md-12 mt-4 text-center">
                                    <button type="submit" class="btn-stack border-0">Enviar</button>
                                 </div>
                            </div>
                        </form>

                        <div class="row mt-5">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table id="excel-table" class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Nombre</th>
                                                <th scope="col">Folio</th>
                                                <th scope="col">Correo</th>
                                                <th scope="col">Fecha de compra</th>
                                                <th scope="col">Sorteo oportuno 1</th>
                                                <th scope="col">Sorteo oportuno 2</th>
                                                <th scope="col">Sorteo oportuno 3</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                           
                                            <ng-container *ngIf="isData && !progress">
                                                <tr >
                                                    <td>{{ dataAll.nombre }}</td>
                                                    <td>{{ dataAll.folio }}</td>
                                                    <td>{{ dataAll.correo }}</td>
                                                    <td>{{ dataAll.dtCompra }}</td>

                                                    <ng-container *ngIf="primerSorteo;else opt0;">
                                                        <td style="background-color: #82cdb6;">
                                                            Participando
                                                            <a (click)="generatePDF(1);" class="btn-d">Generar PDF</a>
                                                        </td>
                                                       
                                                    </ng-container>
                                                    <ng-template #opt0> <td style="background-color: #f7877a;">No valido</td> </ng-template>
                                                    
                                                    <ng-container *ngIf="segundoSorteo;else opt1;">
                                                        <td style="background-color: #82cdb6;">
                                                            Participando
                                                            <a (click)="generatePDF(2);" class="btn-d" >Generar PDF</a>
                                                        </td>
                                                        
                                                    </ng-container>
                                                    <ng-template #opt1> <td  style="background-color: #f7877a;">No valido</td> </ng-template>

                                                    <ng-container *ngIf="tercerSorteo;else opt2;">
                                                        <td style="background-color: #82cdb6;">
                                                            Participando
                                                            <a (click)="generatePDF(3);" class="btn-d" >Generar PDF</a>
                                                        </td>
                                                       
                                                    </ng-container>
                                                    <ng-template #opt2> <td  style="background-color: #f7877a;">No valido</td> </ng-template>
                                                    
                                                   
                                                </tr>                                      
                                            </ng-container>

                                            
                                        </tbody>
                                        
                                    </table>
                                    <div class="text-center">
                                        <ng-container *ngIf="progress">
                                            <div class="spinner-border text-primary mt-2 mb-2" role="status" style="color: #f35f44 !important;">
                                              <span class="sr-only">Loading...</span>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div *ngIf="errorData" class="alert alert-danger" role="alert">
                                        No existen datos.
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        


    </div>
</section>   -->